import ServiceCRUD from '../../../services/ServiceCRUDFLEXCHAT';

class ProductService extends ServiceCRUD {
  constructor() {
    super('produtos');
  }
}

export default new ProductService();
